import { GetPermissionList, SendApprovalData } from "pages/Transactions/Transaction/TransactionController";
import { useEffect, useState } from "react";
import { Button, Row } from "reactstrap";

export const CreditNoteApprovals = ({
    payTxnSetup,
    locationCode,
    locaionName,
    mdBy,
    txnDate,
    TotalPayValue,
    DocumentNo,
    ApprovelDetails,
    GetSelectRow1

}) => {
    return (
        <>
            <Row>
                <h5>Approvals</h5>
            </Row>
            <hr />
            <Row>
                <table>
                    <tbody>
                        <tr>
                            <td style={{ width: "200px" }}>Transaction Type</td>
                            <td>{`${payTxnSetup.pY_TYPE} - ${payTxnSetup.pY_DESC}`}</td>
                            <td style={{ width: "200px" }}>Transaction No</td>
                            <td>{DocumentNo}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "200px" }}>Location</td>
                            <td>{locationCode} - {locaionName}</td>
                            <td style={{ width: "200px" }}>User</td>
                            <td>{mdBy}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "200px" }}>Posted Date</td>
                            <td>{txnDate}</td>
                            <td style={{ width: "200px" }}>Transaction Value</td>
                            <td>{TotalPayValue.toLocaleString(undefined, {
                                maximumFractionDigits: 3,
                                minimumFractionDigits: 2,
                            })}</td>
                        </tr>
                    </tbody>
                </table>
            </Row>
            <Row className="mt-3">
                <table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Approval request</th>
                            <th>Status</th>
                            <th>Checked values</th>
                            <th>Priority</th>
                            <th>Approve Status</th>
                            <th>Approved by</th>
                            <th>Remarks</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(ApprovelDetails).map((data, key) => (
                            <ApprovelDetailRow
                                Key={key}
                                data={data}
                                DocNo={DocumentNo}
                                Transaction={payTxnSetup.pY_TYPE}
                                GetSelectRow1={GetSelectRow1}
                            />
                        ))}
                    </tbody>
                </table>
            </Row>
        </>
    )
};



const ApprovelDetailRow = ({ data, Key, DocNo, Transaction, GetSelectRow1 }) => {
    const [BtnShow, setBtnShow] = useState(false);
    const [remarks, setRemarks] = useState("");


    useEffect(() => {
        CheckPermission();
    }, [])

    const CheckPermission = async () => {
        let permission = await GetPermissionList(data.strRA_TXN_PERMISSION)
        if (permission && Object.keys(permission).length > 0 && permission.strMenuAccessRight && data.shrtRA_APPROVED == 0) {
            setBtnShow(true);
        }
    }

    const SendApprovalDataToEndpoint = async (status) => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        let LogUserType = obj[2]
        let LocationCode = obj[3]
        let CompanyCode = obj[5]
        let body = {
            "recordID": data.id,
            "strUserID": LogUserType,
            "strLocCode": LocationCode,
            "strDocNo": DocNo,
            "strMenuCode": data.strRA_TXN_PERMISSION,
            "intApproval": parseInt(status),
            "strRemarks": remarks,
            "strComCode": CompanyCode,
            "strType": Transaction
        }

        const dataSet = await SendApprovalData(body);
        dataSet == 1 ? GetSelectRow1('', { HED_RUNNO: DocNo }, '', '') : null
    }

    return (
        <tr key={Key + 1}>
            <td>{Key + 1}</td>
            <td>{data.strRA_TXN_PERMISSION}</td>
            <td>{data.isCurrent ? "Active Approval" : "Previous Approval"}</td>
            <td>{data.strRA_REQUEST}</td>
            <td>{data.intRA_PRIORITY}</td>
            <td>{data.shrtRA_APPROVED == 0 ? "Pending" : data.shrtRA_APPROVED == 1 ? "Approved" : data.shrtRA_APPROVED == 2 ? "Rejected" : data.shrtRA_APPROVED == 3 ? "Review" : ""}</td>
            <td>{data.strRA_APPRIVED_BY}</td>
            <td>{BtnShow ? (<input type="text" value={remarks} onChange={(e) => { setRemarks(e.target.value) }} />) : data.strRA_REMARKS}</td>
            <td>
                {BtnShow ? (<Button
                    outline
                    disabled={false}
                    color="success"
                    onClick={e => {
                        SendApprovalDataToEndpoint(1)
                    }}
                    size="sm"
                >
                    Approve <i className="mdi mdi-check-bold" style={{ fontSize: "12px" }}></i>
                </Button>) : null}
            </td>
            <td>
                {BtnShow ? (<Button
                    outline
                    disabled={false}
                    color="danger"
                    onClick={e => {
                        SendApprovalDataToEndpoint(2)
                    }}
                    size="sm"
                >
                    Disapprove <i className="mdi mdi-close-thick" style={{ fontSize: "12px" }}></i>
                </Button>) : null}
            </td>
            <td>
                {BtnShow ? (<Button
                    outline
                    disabled={false}
                    color="primary"
                    onClick={e => {
                        SendApprovalDataToEndpoint(3)
                    }}
                    size="sm"
                >
                    Review <i className="mdi mdi-file-document-edit" style={{ fontSize: "12px" }}></i>
                </Button>) : null}
            </td>
        </tr>
    );
}